namespace Areas.Finance.Reports {
    "use strict";

    let timePeriodText: string;


    export function GetCP509A() {
        const url = `/Finance/Reports/Get509A`;
        window.open(url);
    }

    export function GetCP509Summary() {
        const url = `/Finance/Reports/Get509Summary`;
        window.open(url);
    }

    export function GetCP509B() {
        const form = $("#Report509BForm").dxForm("instance");
        const formData: any = form.option("formData");

        let startDate = formData.startDate;
        if (startDate != null) {
            startDate = moment(formData.startDate).format('YYYY-MM-DD');
        }

        let endDate = formData.endDate;
        if (endDate != null) {
            endDate = moment(formData.endDate).format('YYYY-MM-DD');
        }

        const url = `/Finance/Reports/Get509B/${startDate}/${endDate}`;
        window.open(url);

    }

    export function getStartEndDateFromTimePeriod509B(e) {

        const form = $("#Report509BForm").dxForm("instance");
        const reportData: any = form.option("formData");
        
        if (e.selectedItem == null) {
            timePeriodText = null
            reportData.startDate = null;
            reportData.endDate = null;
            form.option("formData", reportData);

        } else {
            timePeriodText = e.selectedItem.id;

            $.get(`/Finance/Reports/GetStartEndDates/${timePeriodText}`,
                (data) => {

                    reportData.startDate = data.beginDate;
                    reportData.endDate = data.endDate;
                    form.option("formData", reportData);

                });

        }

    }

}